var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"fill-current",attrs:{"width":"40","height":"24","viewBox":"0 0 40 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M33.1535 6L32.1451 7.00846L36.4236 11.2869H0V12.7132H36.4234L32.1451 16.9915L33.1535 18L39.1536 12L33.1535 6Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }